export class CarsDb {
  public static cars: any = [];
}
